"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerificationDynamicCodeForResetLoginPwd = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var dynamicCode_1 = require("../../model/dynamicCode");
var service_1 = require("../../../library/base/service");
var VerificationDynamicCodeForResetLoginPwd = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(VerificationDynamicCodeForResetLoginPwd, _super);
    function VerificationDynamicCodeForResetLoginPwd() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '重置登录密码校验验证码';
        _this.code = '101071';
        _this.desc = '重置登录密码校验验证码';
        _this.requestParams = new dynamicCode_1.VerificationDynamicCodeForResetLoginPwdRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return VerificationDynamicCodeForResetLoginPwd;
}(service_1.BaseService));
exports.VerificationDynamicCodeForResetLoginPwd = VerificationDynamicCodeForResetLoginPwd;
//# sourceMappingURL=verificationDynamicCodeForResetLoginPwd.js.map